import BASEURLGESTTOR from '../api/gesttor'
import { BASEURLGESTTORFORMDATA } from '../api/gesttor'
import { atualizarProcessoTampletPayload, cadastrarTampletPayload, paramsListaModelosTamplet } from '../../interfaces/modelosProcessosTamplets'


export function novoModeloProcessoTamplat (payload: cadastrarTampletPayload) {
    return BASEURLGESTTORFORMDATA.post('/modelosprocessos/tamplet', payload)
} 

export function importarModeloTemplat (idTemplat: string) {
    return BASEURLGESTTOR.post(`/modelosprocessos/tamplet/importar/${idTemplat}`)
}

export function listarModelosProcessosTamplet (params: paramsListaModelosTamplet) {
    return BASEURLGESTTOR.get (`/modelosprocessos/tamplet?termo=${params.termo}&situacao=${params.situacao}`)
}

export function listarModelosProcessosTampletTarefas (idTemplat: string) {
    return BASEURLGESTTOR.get (`/modelosprocessos/tamplet/tarefas/${idTemplat}`)
}

export function atualizarModeloProcessoTamplet (idTemplat: string, payload: atualizarProcessoTampletPayload) {
    return BASEURLGESTTOR.patch(`/modelosprocessos/tamplet/${idTemplat}`, payload)
}

